import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { siteInfo } from '@/mocks/comics';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
      <nav className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-book-open-line text-background-50 text-lg"></i>
          </span>
          <span className="text-xl font-heading font-bold text-foreground-900">{siteInfo.name}</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isActive(link.to)
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200 rounded-full text-foreground-900 placeholder-foreground-400 w-48 focus:w-64 transition-all duration-300 focus:outline-none focus:border-primary-300"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-2">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMobileOpen(false)}
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 cursor-pointer ${
                isActive(link.to)
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="relative mt-2">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-full pl-9 pr-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-full text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>
      )}
    </header>
  );
}